/* Retractation ToutEn3D - amelioration progressive.
 * Sans JS : le formulaire poste nativement vers le Worker, qui renvoie une page de confirmation.
 * Avec JS : envoi AJAX + bascule vers la vue confirmation inline (reste sur /pages/retractation).
 */
(function () {
  'use strict';

  var form = document.getElementById('retract-form');
  if (!form) return;

  try {
    var q = new URLSearchParams(window.location.search);
    setIfEmpty('r-prenom', q.get('prenom') || q.get('name'));
    setIfEmpty('r-email', q.get('email'));
    setIfEmpty('r-commande', q.get('commande') || q.get('order'));
    setIfEmpty('r-date', q.get('date') || q.get('date_commande'));
  } catch (e) { /* ignore */ }

  var ajaxFlag = document.createElement('input');
  ajaxFlag.type = 'hidden';
  ajaxFlag.name = 'ajax';
  ajaxFlag.value = '1';
  form.appendChild(ajaxFlag);

  var btn = document.getElementById('retract-submit');
  var errEl = document.getElementById('retract-error');

  form.addEventListener('submit', function (e) {
    var email = (document.getElementById('r-email').value || '').trim();
    if (!/^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$/.test(email)) {
      e.preventDefault();
      showError('Merci de saisir un email valide.');
      return;
    }

    e.preventDefault();
    hideError();
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Envoi en cours...';

    fetch(form.action, { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.success) {
          showConfirm(data.ref);
        } else {
          btn.disabled = false;
          btn.textContent = original;
          showError((data && data.error) || 'Une erreur est survenue. Merci de reessayer.');
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = original;
        showError('Erreur reseau. Merci de reessayer ou de nous ecrire a contact@toutentroisd.fr.');
      });
  });

  var printBtn = document.getElementById('retract-print');
  if (printBtn) printBtn.addEventListener('click', function () { window.print(); });

  function showConfirm(ref) {
    var refEl = document.getElementById('retract-ref');
    if (refEl) refEl.textContent = ref || '';
    var fv = document.getElementById('retract-form-view');
    var cv = document.getElementById('retract-confirm-view');
    if (fv) fv.hidden = true;
    if (cv) cv.hidden = false;
    try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { /* ignore */ }
  }

  function showError(msg) {
    if (!errEl) { alert(msg); return; }
    errEl.textContent = msg;
    errEl.hidden = false;
  }
  function hideError() { if (errEl) errEl.hidden = true; }

  function setIfEmpty(id, val) {
    var el = document.getElementById(id);
    if (el && !el.value && val) el.value = val;
  }
})();
